/**
 * Єдине джерело базового URL для Laravel, як у api.js та authApi.js.
 * REACT_APP_API_URL зазвичай закінчується на /api/frontend — origin потрібен для /api/*.
 */
export const FRONTEND_API_BASE = (
  process.env.REACT_APP_API_URL || "http://localhost:8000/api/frontend"
).trim();

export function getBackendOrigin() {
  try {
    return new URL(FRONTEND_API_BASE).origin;
  } catch {
    return "http://localhost:8000";
  }
}
